export default __webpack_public_path__ + "static/layout-4dfe45258618961a290b0f05a59adaa8.png";